class ajaxExperts
{
    init()
    {
        $(document).on('click', '.js-loadmore-experts', function() {
            $('.js-loadmore-experts').addClass('load').blur().prop('disabled', true);
            $.ajax({
                url: ajaxurl,
                type: 'POST',
                data: {
                    'action': 'loadMoreExperts',
                    'number': parseInt($('.js-loadmore-experts').data('number')) + parseInt($('.js-loadmore-experts').data('basenumber')),
                    'basenumber': parseInt($('.js-loadmore-experts').data('basenumber')),
                    'totalposts': parseInt($('.js-loadmore-experts').data('totalposts')),
                    'expertid': typeof $('.js-loadmore-experts').data('expertid') != 'undefined' && $('.js-loadmore-experts').data('expertid').toString() != '' ? parseInt($('.js-loadmore-experts').data('expertid')) : ''
                },
            }).done(function (response) {
                $('.js-advice-wrapper').html(response);
                $('.js-loadmore-experts').removeClass('load').prop('disabled', false);
            });
        })
    }
}

export default new ajaxExperts();



// WEBPACK FOOTER //
// ./scripts/src/ajaxExperts.js